import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import { api } from "@/lib/api";

export default function About() {
  const [settings, setSettings] = useState({});
  useEffect(() => { api.get("/public/settings").then((r) => setSettings(r.data)).catch(() => {}); }, []);
  return (
    <Layout>
      <section className="container-msis py-20">
        <div className="overline mb-4">About MSIS</div>
        <h1 className="font-display font-bold text-4xl sm:text-5xl tracking-tighter max-w-3xl">An evidence-based instrument built for management students.</h1>
        <div className="grid lg:grid-cols-3 gap-12 mt-12">
          <div className="lg:col-span-2">
            <p className="text-base text-slate2 leading-relaxed">{settings.about_msis}</p>
            <div className="mt-10 grid sm:grid-cols-2 gap-px bg-border">
              <Block t="Purpose" d="Help management students choose specializations based on their natural orientations rather than peer pressure or perceived salary." />
              <Block t="Method" d="Self-report Likert items aggregated into construct-level and domain-level mean scores with five interpretation bands." />
              <Block t="Audience" d="MBA, PGDM, BBA, EMBA, and management training participants — for individuals as well as cohorts." />
              <Block t="Output" d="A personalized PDF report with domain ranking, construct scores, and academic and career exploration recommendations." />
            </div>
          </div>
          <aside className="space-y-4">
            <div className="card-grid">
              <div className="overline">Test Length</div>
              <div className="font-display font-bold text-2xl mt-2">75 – 225 items</div>
              <div className="text-sm text-slate2 mt-1">Flexibly choose 3 to 9 domains.</div>
            </div>
            <div className="card-grid">
              <div className="overline">Time</div>
              <div className="font-display font-bold text-2xl mt-2">25 – 75 minutes</div>
              <div className="text-sm text-slate2 mt-1">20 seconds per item with auto-advance.</div>
            </div>
            <div className="card-grid">
              <div className="overline">Privacy</div>
              <div className="font-display font-bold text-2xl mt-2">Single-use Test ID</div>
              <div className="text-sm text-slate2 mt-1">Locked to a verified email after OTP.</div>
            </div>
          </aside>
        </div>
      </section>
    </Layout>
  );
}

function Block({ t, d }) {
  return (
    <div className="bg-white p-6">
      <div className="font-display font-bold text-lg">{t}</div>
      <div className="text-sm text-slate2 mt-2 leading-relaxed">{d}</div>
    </div>
  );
}
